import Vue from 'vue'
import Vuex from 'vuex'
import {OperationsCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        data:{
          name:'',
          hasDestinationWarehouse: false,
        },
        record:{},
        selectedKey: ''
      },
      mutations: {
        cleanSelectedKey:(state)=>{
          state.selectedKey=''
        },
        getAllItems(state, item) {
          Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
          Vue.delete(state.record,key)
        }        
      },
      actions: {
        
        getAll:(context)=>{
          context.state.record = {}
          OperationsCollection.orderBy('name', 'asc').onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
          
        },
        add:context=>{
          if(context.state.selectedKey==''){
            OperationsCollection.add({...context.state.data, createdAt:new Date, code: context.state.data.code.padStart(2, 0), name: context.state.data.name.toUpperCase() }).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo tipo de recibo correctamente', { root: true })
              cleanObject(context.state.data)})
          } else {
            OperationsCollection.doc(context.state.selectedKey).update({...context.state.data, code: context.state.data.code.padStart(2, 0), name: context.state.data.name.toUpperCase()}).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.data)
            })
          }
        },
        clean:(context, key)=>{
          OperationsCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean', key)})
        },
        get:(context, key)=>{
          OperationsCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
          })
        },
      },
      getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item, name: state.record[item].code +' - '+ state.record[item].name  }) ),
        outputRecord: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ).filter(item=>item.isOutputCategory),
        inputRecord: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ).filter(item=>item.isInputCategory),
      },
  }
  